export default {
  async postDataWithToken(url, dataObj, token) {
    const response = await fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(dataObj),
    });
    const data = await response.json();
    return data;
  },
  async postData(url, dataObj) {
    const response = await fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dataObj),
    });
    const data = await response.json();
    return data;
  },

  async getData(url, token) {
    const response = await fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    const data = await response.json();
    return data;
  },

  async createService(url, name, cost, price, categoryID, code, list, token) {
    const service = await this.postDataWithToken(
      url,
      {
        name: name,
        code: code,
        cost: cost,
        price: price,
        categoryID: categoryID,
        list: list,
      },
      token
    );
    return service;
  },
  async createStaff(
    url,
    name,
    idNumber,
    phone,
    email,
    city,
    address,
    token,
    branchID = null,
    conferenceID = null
  ) {
    return this.postDataWithToken(
      url,
      {
        name,
        idNumber,
        phone,
        email,
        city,
        address,
        branchID,
        conferenceID,
      },
      token
    );
  },

  async updateModelSingleRow(url, table, column, id, value, token) {
    const response = await this.postDataWithToken(
      url,
      {
        table,
        column,
        id,
        value,
      },
      token
    );
    return response;
  },

  async submitEarningsAndDeductions(
    url,
    amount,
    selectedCategory,
    description,
    employeesIDs,
    payrollID,
    token,
    branchID = null,
    conferenceID = null
  ) {
    const payrolls = this.postDataWithToken(
      url,
      {
        amount,
        selectedCategory,
        description,
        employeesIDs,
        payrollID,
        branchID,
        conferenceID,
      },
      token
    );

    return payrolls;
  },

  async createSalary(
    url,
    description,
    amount,
    token,
    branchID = null,
    conferenceID = null
  ) {
    const salary = this.postDataWithToken(
      url,
      { amount: amount, name: description, branchID, conferenceID },
      token
    );
    return salary;
  },

  async createStaffRate(
    url,
    description,
    rate,
    token,
    branchID = null,
    conferenceID = null
  ) {
    const newRate = await this.postDataWithToken(
      url,
      { rate: rate, name: description, branchID, conferenceID },
      token
    );
    return newRate;
  },

  async createPayrol(
    url,
    month,
    year,
    payDate,
    token,
    branchID = null,
    conferenceID = null
  ) {
    const payrolls = await this.postDataWithToken(
      url,
      {
        month,
        year,
        payDate,
        branchID,
        conferenceID,
      },
      token
    );
    return payrolls;
  },

  async getAllPayrolls(url, token, branchID = null, conferenceID = null) {
    const payrolls = await this.postDataWithToken(
      url,
      { branchID, conferenceID },
      token
    );
    return payrolls;
  },

  async getAllStaffCategories(
    url,
    token,
    branchID = null,
    conferenceID = null
  ) {
    const staffCategories = await this.postDataWithToken(
      url,
      { branchID, conferenceID },
      token
    );
    return staffCategories;
  },

  async getAllStaff(url, token, branchID = null, conferenceID = null) {
    const response = await this.postDataWithToken(
      url,
      { branchID, conferenceID },
      token
    );
    return response;
  },
  async deleteSelectedEmployeesNow(
    url,
    selectedStaff,
    token,
    branchID = null,
    conferenceID = null
  ) {
    const staff = await this.postDataWithToken(
      url,
      {
        selectedEmployees: selectedStaff,
        branchID,
        conferenceID,
      },
      token
    );
    return staff;
  },
  async addSelectedStaffToAPayroll(
    url,
    selectedEmployeesIDs,
    selectedPayrollID,
    token,
    branchID = null,
    conferenceID = null
  ) {
    const payslips = await this.postDataWithToken(
      url,
      {
        selectedEmployeesIDs,
        selectedPayrollID,
        branchID,
        conferenceID,
      },
      token
    );
    return payslips;
  },
  async getAllSalaries(url, token, branchID = null, conferenceID = null) {
    const salaries = await this.postDataWithToken(
      url,
      { branchID, conferenceID },
      token
    );
    return salaries;
  },
  async getAllPayrolls(url, token, branchID = null, conferenceID = null) {
    const payrolls = await this.postDataWithToken(
      url,
      { branchID, conferenceID },
      token
    );
    return payrolls;
  },
  async getAllAgencyFees(url, token) {
    const fees = await this.getData(url, token);
    return fees;
  },
  async applySalaryToStaff(
    url,
    selectedStaffIDs,
    selectedSalaryID,
    token,
    branchID = null,
    conferenceID = null
  ) {
    const staff = await this.postDataWithToken(
      url,
      {
        staffIDNumbers: selectedStaffIDs,
        salaryID: selectedSalaryID,
        branchID,
        conferenceID,
      },
      token
    );
    return staff;
  },
  async applyRateToStaff(
    url,
    selectedStaffIDs,
    selectedRateID,
    hoursWorked,
    total,
    payrollMonth,
    agencyFee,
    agencyFeeName,
    token,
    branchID = null,
    conferenceID = null
  ) {
    const staff = await this.postDataWithToken(
      url,
      {
        selectedStaffIDs,
        hoursWorked,
        selectedRateID,
        total,
        payrollMonth,
        agencyFee,
        agencyFeeName,
        branchID,
        conferenceID,
      },
      token
    );
    return staff;
  },
  async getAllRates(url, token, branchID = null, conferenceID = null) {
    const rates = await this.postDataWithToken(
      url,
      { branchID, conferenceID },
      token
    );
    return rates;
  },
  async getForeignTableData(url, table, column, token, branchID = null) {
    if (table) {
      const rowData = await this.postDataWithToken(
        url,
        { table, column, branchID },
        token
      );
      return rowData;
    } else {
      return [];
    }
  },
  async getForeignFieldValue(url, table, foreignID, token) {
    const name = await this.postDataWithToken(
      url,
      {
        table,
        foreignID,
      },
      token
    );
    return name;
  },
  async getAllClients(url, token) {
    const clients = await this.getData(url, token);
    return clients;
  },
  async getAllEvents(url, status, emis) {
    const events = await this.postData(url, {
      emis,
      status,
    });
    return events;
  },
  async getAllAgencyFees(url, token) {
    const fees = await this.getData(url, token);
    return fees;
  },
  stripNonDigitsAndCommasFromMoney(amount) {
    const newAmount = amount.replace(/[^\d.-]/g, "");
    return newAmount.trim();
  },
  stripCommasFromMoney(amount) {
    let newAmount = amount;
    if (amount) {
      if (amount.includes(",")) {
        newAmount = amount.replace(",", "");
      }

      if (amount.includes("R")) {
        newAmount = amount.replace("R", "");
      }

      if (amount.includes("ZAR")) {
        newAmount = amount.replace("ZAR", "");
      }
      return newAmount.trim();
    } else {
      return 0;
    }
  },
  formatUnderscoreNamesWithFirstCapitalLetters(name) {
    let formattedName = "";
    if (name && name.includes("_")) {
      formattedName = name.replace("_", " ");
    } else {
      formattedName = name;
    }

    const names = formattedName.split(" ");
    if (names.length > 1) {
      let parts = "";
      names.forEach((tab) => {
        parts += this.capitalizeFirstCharacter(tab) + " ";
      });
      formattedName = parts;
    } else {
      formattedName = this.capitalizeFirstCharacter(names[0]);
    }
    return formattedName;
  },
  capitalizeFirstCharacter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },
  async getClientInvoices(url, clientReference, token) {
    const invoices = await this.postDataWithToken(
      url,
      { clientReference },
      token
    );
    return invoices;
  },
  async saveEvent(
    url,
    payload,
    selectedAgencyFee,
    selectedPayrollID,
    selectedInvoiceID,
    token
  ) {
    const events = await this.postDataWithToken(
      url,
      {
        eventId: payload.id,
        title: payload.title,
        description: payload.description,
        startDate: payload.start,
        endDate: payload.end,
        privacy: payload.private,
        rateID: payload.rateID,
        hours: payload.hours,
        agencyFee: selectedAgencyFee.percentage,
        agencyFeeName: selectedAgencyFee.name,
        clientID: payload.clientID,
        staffIDs: payload.staffIDs,
        selectedPayrollID: selectedPayrollID,
        selectedInvoiceID: selectedInvoiceID,
      },
      token
    );
    return events;
  },
  getColors() {
    return [
      "#F44336",
      "#E91E63",
      "#9C27B0",
      "#673AB7",
      "#3F51B5",
      "#2196F3",
      "#03A9F4",
      "#00BCD4",
      "#009688",
      "#4CAF50",
      "#8BC34A",
      "#CDDC39",
      "#FFEB3B",
      "#FFC107",
      "#FF9800",
      "#FF5722",
      "#795548",
      "#9E9E9E",
      "#607D8B",
      "#000000",
      "#FFFFFF",
      "#F8BBD0",
      "#9575CD",
      "#80CBC4",
      "#FFCC80",
      "#E6EE9C",
      "#E3F2FD",
      "#E0F7FA",
      "#E8F5E9",
      "#FFF9C4",
      "#E8EAF6",
      "#FCE4EC",
      "#FFEBEE",
      "#F3E5F5",
      "#E1F5FE",
      "#FFF3E0",
      "#EFEBE9",
      "#FAFAFA",
      "#ECEFF1",
      "#9FA8DA",

      "#311B92",
      "#FF9800",
      "#37474F",
      "#009688",
      "#2196F3",
      "#9C27B0",
      "#000000",
      "#880E4F",
      "#3E2723",
      "#F44336",
      "#FFAB00",
      "#E65100",
      "#827717",
      "#3E2723",
      "#000000",
      "purple",
    ];
  },
};
